import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileIcon, defaultStyles } from 'react-file-icon';
import axios from "axios";
import { headers } from '../../token';
import config from "../../config";
import { saveAs } from 'file-saver';
import { Flat } from '@alptugidin/react-circular-progress-bar';
import UpdateBussinessFile from "./UpdateBussinessFile";
import DeleteBussinessFile from "./DeleteBussinessFile";
import ViewsBussinessFile from "./ViewsBussinessFile";
import vAdminformat from "../../adminFormat";
import Swal from "sweetalert2";

const server_backend = config.API_URL;

const MyStlBussinessLibrary = ({ username }) => {
    const [isUploading, setIsUploading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isDragging, setIsDragging] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);
    const [getFiles, setGetFiles] = useState([]);
    const [DownloadModalFile, setDownloadModalFile] = useState(false);
    const [loadingFilesInServer, setLoadingFilesInServer] = useState(false);
    const [files, setFiles] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [ViewFile, setViewFile] = useState(false);
    const [CurrenURLFile, setCurrenURLFile] = useState("");
    const [statusFiles, setStatusFiles] = useState([]);

    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState("");
    const [selectedFilter, setSelectedFilter] = useState("");
    const [currentFileName, setcurrentFileName] = useState("");
    const [onFileID, setOnFileID] = useState(0);
    const [filesUploaded, setFilesUploaded] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const CHUNK_SIZE = 10240 * 10240;

    const handleFileSelect = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles(files);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        setSelectedFiles(files);
        setIsDragging(false);
    };


    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        const iconStyles = defaultStyles[extension] || defaultStyles.default;
        return <FileIcon extension={extension} {...iconStyles} />;
    };

    useEffect(() => {
        const getBussinessLibrary = async () => {
            try {
                const response = await axios.get(`${server_backend}/files/private/list?user_transaction=${username}`, headers);
                if (response.data.RES_CODE === "00") {
                    setGetFiles(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getBussinessLibrary();
    }, []);

    const getBussinessLibrary = async () => {
        try {
            const response = await axios.get(`${server_backend}/files/private/list?user_transaction=${username}`, headers);

            if (response.data.RES_CODE === "00") {
                setGetFiles(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleUpload = async (event) => {
        event.preventDefault();
        setIsMinimized(false);
        setIsUploading(false);
        setLoadingFilesInServer(true);

        const uploadFile = async (file) => {
            setDownloadModalFile(true);
            const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            let fileName = file.name;

            try {
                const checkResponse = await axios.get(
                    `${server_backend}/files/private/exists?name=${file.name}`,
                    headers
                );

                if (checkResponse.data.RES_CODE === "00") {

                    const now = new Date();
                    const formattedDate = now.toISOString().replace(/[-:.TZ]/g, "");
                    const fileExtension = file.name.split(".").pop();
                    const fileBaseName = file.name.replace(`.${fileExtension}`, "");

                    fileName = `${fileBaseName}_${formattedDate}.${fileExtension}`;
                }
            } catch (error) {
                console.error("Error comprobando si el archivo existe:", error);
            }

            for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                const start = chunkIndex * CHUNK_SIZE;
                const end = Math.min(start + CHUNK_SIZE, file.size);
                const chunk = file.slice(start, end);

                const formData = new FormData();
                formData.append("chunk", chunk);
                formData.append("chunkIndex", chunkIndex);
                formData.append("totalChunks", totalChunks);
                formData.append("name", fileName);
                formData.append("user_transaction", username);

                const config = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: headers.headers.Authorization,
                    },
                    onUploadProgress: (progressEvent) => {
                        const overallProgress = Math.round(
                            ((chunkIndex + 1) * 100) / totalChunks
                        );

                        setFiles((prevFiles) =>
                            prevFiles.map((f) =>
                                f.name === file.name
                                    ? { ...f, progress: overallProgress }
                                    : f
                            )
                        );
                    },
                };

                try {
                    await axios.post(
                        `${server_backend}/files/private/insert`,
                        formData,
                        config
                    );
                } catch (error) {
                    console.error(`Error subiendo el fragmento ${chunkIndex}:`, error);
                }
            }


            setFilesUploaded((prevFiles) => [...prevFiles, { name: fileName, progress: 100 }]);
        };

        try {

            const initialFiles = selectedFiles.map((file) => ({
                name: file.name,
                progress: 0,
            }));
            setFiles(initialFiles);


            for (let i = 0; i < selectedFiles.length; i++) {
                await uploadFile(selectedFiles[i]);
            }
        } catch (error) {
            console.error("Error Uploading Files:", error);
        } finally {
            setLoadingFilesInServer(false);
            getBussinessLibrary();
            setIsUploading(false);
        }
    };

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
    };

    const FilterFiles = async () => {
        try {
            const response = await axios.get(`${server_backend}/files/private/search?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setGetFiles(response.data.RES_RESULT);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterFiles();
        } else {
            getBussinessLibrary();
        }
    }, [filterBy, filterStatus, filterValue, filtersEnabled]);

    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    };

    const CloseModal = () => {
        setIsUpdating(false);
    };

    const ShowViewFiles = () => {
        setViewFile(true);
    }
    const CloseViewFiles = () => {
        setViewFile(false);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = getFiles.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(getFiles.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Handle the checkboxes selection

    const handleCheckboxChange = (fileID) => {
        setSelectedFiles(prev =>
            prev.includes(fileID) ? prev.filter(id => id !== fileID) : [...prev, fileID]
        );
    };

    // Handles selected files

    const handleDeleteSelected = () => {

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to delete these file? This action cannot be undone.",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    selectedFiles.forEach(fileID => DeleteBussinessFile(fileID));

                } catch (error) {
                    console.log(error)
                } finally {
                    setSelectedFiles([]); 
                    getBussinessLibrary();
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',   
                        text: "Success.",
                        showConfirmButton: false,
                        timer: 1000
                    })
                }
            }
        });
    };

    return (
        <div className="page-content" style={{ overflow: "auto" }}>
            {ViewFile ? (
                <ViewsBussinessFile CloseViewFiles={CloseViewFiles} urlFile={CurrenURLFile} Filename={currentFileName} />
            ) : (
                <div>
                    {!isUploading ? (
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">Bussiness Files</h4>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a href="javascript: void(0);">Files</a></li>
                                                <li className="breadcrumb-item active">Library</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card" id="tasksList">
                                        <div className="card-header border-0">
                                            <div className="d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">All Files</h5>
                                                
                                                <div className="col-xxl-2 col-sm-2" style={{ paddingRight: "2px" }}>
                                                    {selectedFiles.length > 0 && (
                                                        <button className="btn btn-danger w-100" onClick={handleDeleteSelected}>
                                                            Delete {selectedFiles.length} File(s)
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                                    <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                        <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                                    </button>
                                                </div>
                                                <div className="flex-shrink-0">
                                                    <Link className="btn btn-danger" onClick={() => setIsUploading(true)}>
                                                        <i className="ri-upload-2-fill me-1 align-bottom"></i> Upload File
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        {filtersEnabled && (
                                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                                <form>
                                                    <div className="row g-3">
                                                        <div className="col-4">
                                                            <div className="input-light">
                                                                <select
                                                                    className="form-control custom-select-style"
                                                                    disabled={!filtersEnabled}
                                                                    value={filterBy} // Change to filterby

                                                                    onChange={handleFilterByChange}
                                                                >
                                                                    <option>Filter by</option>
                                                                    <option value="name">Name</option>
                                                                    <option value="type">type</option>
                                                                    <option value="size">size</option>

                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-4">
                                                            <div className="input-light">
                                                                <select
                                                                    className="form-control custom-select-style"
                                                                    disabled={!filtersEnabled}
                                                                    onChange={handleFilterStatusChange}
                                                                >
                                                                    <option value={0}>Filter status</option>
                                                                    {statusFiles.map((status) => (
                                                                        <option value={status.est_ID}>{status.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="search-box">
                                                                <input
                                                                    type="text"
                                                                    className="form-control search bg-light border-light"
                                                                    placeholder="Search for tasks or something..."
                                                                    onChange={handleFilterValueChange}
                                                                />
                                                                <i className="ri-search-line search-icon"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        )}
                                        <div className="card-body">
                                            <div className="table-responsive table-card mb-4" style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}>
                                                <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th><input type="checkbox" disabled /></th>
                                                            <th scope="col">File Name</th>
                                                            <th scope="col">Type</th>
                                                            <th scope="col">Size</th>
                                                            <th scope="col">Upload Date</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentItems.map((Files_M) => (
                                                            <tr key={Files_M.file_ID}>
                                                                <td>
                                                                    <div className="form-check">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id={`checkbox-${Files_M.file_ID}`}
                                                                            checked={selectedFiles.includes(Files_M.file_ID)}
                                                                            onChange={() => handleCheckboxChange(Files_M.file_ID)}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`checkbox-${Files_M.file_ID}`}></label>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <div className="d-flex align-items-center">
                                                                        <div style={{ width: "24px", height: "24px" }}>
                                                                            {getFileIcon(Files_M.name)}
                                                                        </div>
                                                                        <div className="ms-3 flex-grow-1">
                                                                            <p className="text-bold mb-0">
                                                                                <Link
                                                                                    onClick={() => {
                                                                                        ShowViewFiles();
                                                                                        const backendFilePath = `${server_backend}/${Files_M.path_file}`;
                                                                                        setCurrenURLFile(backendFilePath);
                                                                                        setcurrentFileName(Files_M.name);
                                                                                    }}
                                                                                    className="text-truncate d-inline-block"
                                                                                    style={{ maxWidth: '350px' }}
                                                                                    title={Files_M.name}
                                                                                >
                                                                                    {Files_M.name}
                                                                                </Link>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>{Files_M.extension}</td>
                                                                <td>{Files_M.size}</td>
                                                                <td>{vAdminformat.FormatDate(Files_M.date_created)}</td>
                                                                <td>
                                                                    <span className={`${Files_M.est_ID === 1 ? "badge badge-soft-success text-uppercase"
                                                                        : (Files_M.est_ID === 2 ? "badge badge-soft-danger text-uppercase"
                                                                            : (Files_M.est_ID === 3 ? "badge badge-label bg-danger" : null)
                                                                        )} text-uppercase`}>
                                                                        {Files_M.status_name}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex align-items-center justify-content-around">
                                                                        <Link className="text-muted" onClick={() => {
                                                                            ShowViewFiles();
                                                                            const backendFilePath = `${server_backend}/${Files_M.path_file}`;
                                                                            setCurrenURLFile(backendFilePath);
                                                                            setcurrentFileName(Files_M.name);
                                                                        }}>
                                                                            <i className="ri-eye-fill fs-5"></i>
                                                                        </Link>
                                                                        <Link className="text-muted" onClick={() => {
                                                                            ShowModalUpdate();
                                                                            setOnFileID(Files_M.file_ID);
                                                                        }}>
                                                                            <i className="ri-pencil-fill fs-5"></i>
                                                                        </Link>
                                                                        <Link className="text-muted" onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            const backendFilePath = `${server_backend}/${Files_M.path_file}`;
                                                                            const fileNameWithoutSpaces = Files_M.name.replace(/\s/g, '');
                                                                            saveAs(backendFilePath, fileNameWithoutSpaces);
                                                                        }}>
                                                                            <i className="ri-download-2-fill fs-5"></i>
                                                                        </Link>
                                                                        <Link className="text-muted" onClick={() => {
                                                                            Swal.fire({
                                                                                icon: 'warning',
                                                                                title: 'Alert',
                                                                                text: "Are you sure you want to delete this file? This action cannot be undone.",
                                                                                showCancelButton: true,
                                                                                confirmButtonText: 'Accept',
                                                                                cancelButtonText: "Cancel"
                                                                            }).then(async (result) => {
                                                                                if (result.isConfirmed) {

                                                                                    DeleteBussinessFile(Files_M.file_ID, getBussinessLibrary);

                                                                                }
                                                                            });
                                                                        }}>
                                                                            <i className="ri-delete-bin-5-line fs-5"></i>
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row justify-content-between align-items-center">
                                                <div className="col-auto me-3">
                                                    <p className="text-muted mb-sm-0">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, getFiles.length)} of {getFiles.length} entries</p>
                                                </div>
                                                <div className="col-auto">
                                                    <ul className="pagination pagination-separated pagination-sm justify-content-end mb-sm-0">
                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(currentPage - 1)} className="page-link">←</a>
                                                        </li>
                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                            <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                                <a href="#" onClick={() => handlePageChange(index + 1)} className="page-link">{index + 1}</a>
                                                            </li>
                                                        ))}
                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(currentPage + 1)} className="page-link">→</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-body">
                                    <center><h5>Upload Files</h5></center>
                                    <button className="btn btn-warning" onClick={() => setIsUploading(false)}>Go back</button>
                                </div>
                                <div className="p-5">
                                    <div
                                        className={`custom-scrollbar-wrapper ${isDragging ? "dragging" : ""}`}
                                        style={{ minHeight: "40vh", borderRadius: "10px", border: "2px dashed #ccc", padding: "20px" }}
                                        onDragOver={handleDragOver}
                                        onDrop={handleDrop}
                                    >
                                        <div className="custom-file-input" style={{ textAlign: "center", padding: "50px 20px", borderRadius: "10px", backgroundColor: "#f8f9fa" }}>
                                            <input
                                                id="fileInput"
                                                type="file"
                                                multiple
                                                style={{ display: "none" }}
                                                onChange={handleFileSelect}
                                                accept=".stl, .img, .jpg, .jepg, .obj"
                                            />
                                            <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                                                <h1 className="fw-bold">Drag the file here</h1>
                                                <p>or click to select files</p>
                                            </label>
                                        </div>
                                        <ul className="list-unstyled chat-list chat-user-list mt-3">
                                            {selectedFiles.map((file, index) => (
                                                <li key={index}>
                                                    <Link to="#" className="unread-msg-user">
                                                        <div className="d-flex">
                                                            <div className="chat-user-img align-self-center me-3 ms-0">
                                                                <div className="avatar-xs">
                                                                    <div className="avatar-title bg-soft-primary text-primary rounded fs-20">
                                                                        <FileIcon fileName={file.name} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 overflow-hidden">
                                                                <h5 className="text-truncate fs-14 mb-0">{file.name}</h5>
                                                            </div>

                                                        </div>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                        {selectedFiles.length > 0 && (
                                            <div className="mt-3 text-center">
                                                <button className="btn btn-primary" onClick={handleUpload}>Upload Files</button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    )}
                    {isUpdating && (
                        <UpdateBussinessFile onBussinessFileID={onFileID} onClose={CloseModal} getBussinessLibrary={getBussinessLibrary} />
                    )}

                </div>

            )}

            {DownloadModalFile && (
                <div
                    className={`upload-progress-container azoomOutDown ${isMinimized ? "minimized" : ""
                        }`}
                    style={{ height: isMinimized ? "10%" : "60%" }}
                >
                    <div
                        className="upload-progress-header"
                        style={{ backgroundColor: "#545454" }}
                    >
                        <center>
                            <h5 className="text-white">Uploading Files</h5>
                        </center>
                        <div style={{ padding: 0 }}>
                            <button
                                onClick={() => setIsMinimized(!isMinimized)}
                                className="minimize-button"
                                style={{ paddingLeft: "10px" }}
                            >
                                {isMinimized ? (
                                    <button
                                        className="btn btn-outline-primary"
                                        style={{ borderRadius: "56%", marginRight: "4px" }}
                                    >
                                        <i
                                            className="ri-arrow-up-s-line"
                                            style={{ fontSize: "10px", color: "white" }}
                                        ></i>
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-outline-primary"
                                        style={{ borderRadius: "56%", marginRight: "4px" }}
                                    >
                                        <i
                                            className="ri-arrow-down-s-line"
                                            style={{ fontSize: "10px", color: "white" }}
                                        ></i>
                                    </button>
                                )}
                                <button
                                    className="btn btn-outline-primary"
                                    onClick={() => {
                                        setDownloadModalFile(false);
                                        setSelectedFiles([]);
                                        setIsMinimized(false);
                                    }}
                                    style={{ borderRadius: "56%" }}
                                >
                                    <i
                                        className="ri-close-line"
                                        style={{ fontSize: "10px", color: "white" }}
                                    ></i>
                                </button>
                            </button>
                        </div>
                    </div>
                    {!isMinimized && (
                        <div>
                            <div className="upload-progress-content">
                                {files.map((file, index) => (
                                    <div key={index} className="upload-progress-item">
                                        <span>
                                            <div style={{ width: "23px" }}>
                                                <FileIcon fileName={file.name} />
                                            </div>
                                        </span>
                                        <span className="truncate">{file.name}</span>
                                        <div
                                            style={{ width: "13%" }}
                                            className="fw-bold"
                                        >
                                            <Flat
                                                progress={file.progress}
                                                sx={{
                                                    strokeColor: `${file.progress === 100
                                                        ? "green"
                                                        : "#4281ff"
                                                        }`,
                                                    barWidth: 10,
                                                    miniCircleColor: "#095677",
                                                    miniCircleSize: 11,
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {loadingFilesInServer && (
                                <div className="p-2 text-primary fw-bold">
                                    <p>
                                        The server is processing the files, please wait
                                        <span className="dots"></span>
                                    </p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}


        </div>
    );
};

export default MyStlBussinessLibrary;

